import React from "react";
import { Link } from "react-router-dom";

import "./styles/project.css";

const Project = (props) => {
	const { logo, title, description, linkText, link, index, stage, tags } = props;
	const projectNum = String((index ?? 0) + 1).padStart(2, "0");

	const Container = linkText ? Link : "div";

	return (
		<React.Fragment>
			<div className={`project${stage ? " project--wip" : ""}`}>
				<Container
					to={linkText ? link : null}
					target={linkText ? "_blank" : null}
				>
					<div className="project-container">
						<div className="project-header">
							{logo && (
								<div className="project-logo">
									<img src={logo} alt="logo" />
								</div>
							)}
							<div className="project-num">{projectNum}</div>
						</div>
						<div className="project-title">{title}</div>
						<div className="project-description">{description}</div>
						{linkText && (
							<div className="project-link">
								<span className="project-link-arrow">►</span>
								<span className="project-link-text">
									{linkText}
								</span>
							</div>
						)}
						{stage && (
							<div className="project-stage">
								<span className="project-stage-cursor">■</span>
								<span className="project-stage-label">{stage}</span>
							</div>
						)}
						{tags && tags.length > 0 && (
							<div className="project-tags">
								{tags.map((tag, i) => (
									<span key={i} className="project-tag">{tag}</span>
								))}
							</div>
						)}
					</div>
				</Container>
				<div className="project-corner top-left" />
				<div className="project-corner top-right" />
				<div className="project-corner bottom-left" />
				<div className="project-corner bottom-right" />
			</div>
		</React.Fragment>
	);
};

export default Project;
